import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconShieldPerson from '@/shared/icons/NewDesign/IconShieldPerson'
import IconPhone from '@/shared/icons/NewDesign/IconPhone'
import IconUser from '@/shared/icons/NewDesign/IconUser'
import IconFlagFR from '@/shared/icons/NewDesign/Flags/IconFlagFR'
import IconFlagBE from '@/shared/icons/NewDesign/Flags/IconFlagBE'
import IconFlagIT from '@/shared/icons/NewDesign/Flags/IconFlagIT'
import IconFlagNL from '@/shared/icons/NewDesign/Flags/IconFlagNL'

import {
  BUSINESS_VERTICAL_ENERGY,
  BUSINESS_VERTICAL_INSURANCE,
  BUSINESS_VERTICAL_TELECOM,
} from '../../../SubscriptionFormPageNew/SubscriptionForm/Common/constants'
import IconFlagWorld from '@/shared/icons/NewDesign/Flags/IconFlagWorld'

export const CONTRACT_TYPE_ICON_BY_TYPE = {
  [BUSINESS_VERTICAL_ENERGY]: IconBolt,
  [BUSINESS_VERTICAL_INSURANCE]: IconShieldPerson,
  [BUSINESS_VERTICAL_TELECOM]: IconPhone,
}

export const getContractTypeIconComponent = contractType => {
  const type = String(contractType || '')
  return CONTRACT_TYPE_ICON_BY_TYPE[type] || IconUser
}

export const flagByCountry = {
  fr: IconFlagFR,
  be: IconFlagBE,
  it: IconFlagIT,
  nl: IconFlagNL,
}

export const buildCountrySelectOptions = t => [
  { id: 'all', label: t('contacts.filter_all_countries'), FlagIcon: IconFlagWorld },
  { id: 'fr', label: 'France', FlagIcon: IconFlagFR },
  { id: 'be', label: 'Belgique', FlagIcon: IconFlagBE },
  { id: 'it', label: 'Italie', FlagIcon: IconFlagIT },
  { id: 'nl', label: 'Nederland', FlagIcon: IconFlagNL },
]
